import { render, staticRenderFns } from "./Indexxy.vue?vue&type=template&id=3069d8ae&"
import script from "./Indexxy.vue?vue&type=script&lang=js&"
export * from "./Indexxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports